import { apiPath } from '../../constants';
import { axios, apiRequestOptions, transformHttpResponse } from 'utils';

export const MERGE_CANDIDATES_REQUEST = 'MERGE_CANDIDATES_REQUEST';
export const MERGE_CANDIDATES_SUCCESS = 'MERGE_CANDIDATES_SUCCESS';
export const MERGE_CANDIDATES_FAILURE = 'MERGE_CANDIDATES_FAILURE';

/**
 * Fetches competitions eligible to be merged with the given competition.
 * Backend guarantees: same location, overlapping dates, not the competition itself.
 *
 * @param {string} competitionId
 */
export const fetchMergeCandidates = (competitionId) => {
  return function (dispatch) {
    dispatch({ type: MERGE_CANDIDATES_REQUEST, competitionId });

    return axios(
      apiRequestOptions(apiPath.SCHEDULE.MERGE_CANDIDATES, null, { params: { id: competitionId } })
    )
      .then(transformHttpResponse)
      .then(response =>
        dispatch({
          type: MERGE_CANDIDATES_SUCCESS,
          competitionId,
          data: response.data.candidates,
        })
      )
      .catch(error => transformHttpResponse(error.response))
      .catch(() => {
        dispatch({ type: MERGE_CANDIDATES_FAILURE, competitionId });
      });
  };
};
